import React from "react";
import styled from "styled-components";
import { useHistory, useLocation} from "react-router-dom";
import { useDispatch } from "react-redux";
import { modifyWordFB } from "../redux/modules/word";


const Modify = (props) =>{

    const location =useLocation();
    const dispatch =useDispatch();
    const history =useHistory();

    const word = React.useRef(null); //초기값은 null 단어
    const desc = React.useRef(null); //초기값은 null 설명
    const example = React.useRef(null); //초기값은 null 예시

    const stateId=location.state.id;
    const stateWord=location.state.word;
    const stateDesc=location.state.desc;
    const stateEx=location.state.example;
    const stateCom=location.state.completed;
    
   
        

     

    const editWord =()=>{

        dispatch(
            modifyWordFB(stateId,{
                 word: word.current.value.trim(),
                desc: desc.current.value.trim(),
                example: example.current.value.trim(),
                completed:stateCom
            })
            
        )
        history.push("/");
    }

    
    return (
        <>
        <AddOutter>
            <div>
                <h3>단어 수정하기</h3>
                <WordBox>
                    <div>
                        <label>단어</label>
                        <input type="text" ref={word} defaultValue={stateWord}/> 
                    </div>
                    <div>
                        <label>설명</label>
                        <input type="text" ref={desc} defaultValue={stateDesc}/>
                    </div>
                    <div>
                        <label>예시</label>
                         <input type="text" ref={example} defaultValue={stateEx}/> 
                    </div>
                    <button type="submit" onClick={editWord}>단어 수정</button>
                </WordBox>
            </div>
            
        </AddOutter>
    </>
    );
}
//스타일
const AddOutter=styled.section`
    width:100%;
    position:relative;
    top:80px;
    height:100%;
    padding:60px;
    display:flex;
    justify-content:center;
    
    @media screen and (max-width: 500px){
        top:60px;
        }

        & > div{
            width:400px;
            min-height: 70vh;
            background: #e4ebfb;
            border-radius:8px;
            position:relative;
        }
        & > div> h3{
            width: 100%;
            text-align:center;
            font-size: 36px;
            padding:10px;
            font-family:"Dongle";
            @media screen and (max-width: 500px){
                font-size: 30px;
            }
        }
`;
const WordBox =styled.div`
            width:100%;
            height:320px;
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
            gap:50px;

        & div {
            
        }
        & label{
            font-family:"Dongle";
            font-size:32px;
            margin-right:10px;
        }
        & input{
            width:200px;
            height:40px;
            border: 1px solid #97ACE3;
            border-radius:5px;
        }
        & input:focus {
            border: 1px solid #123389;
        }
        & > button {
            width:150px;
            height:40px;
            font-family:"Dongle";
            font-size:32px;
            cursor:pointer;
            border-radius:5px;
            background:#97ACE3;
            color:#123389;
        }
        & > button:hover{
            background:#123389;
            color:#97ACE3;
        }
`;

export default Modify;